import React from 'react';
import PropTypes from 'prop-types';

import './Skeleton.css';

const Skeleton = ({
    width,
    height,
    mt,
    mr,
    mb,
    ml,
    minWidth,
    borderRadius,
}) => {
    borderRadius =
        typeof borderRadius === 'string' ? borderRadius : borderRadius + 'px';
    width = typeof width === 'string' ? width : width + 'px';
    height = typeof height === 'string' ? height : height + 'px';
    mb = typeof mb === 'string' ? mb : mb + 'px';
    ml = typeof ml === 'string' ? ml : ml + 'px';
    mr = typeof mr === 'string' ? mr : mr + 'px';
    mt = typeof mt === 'string' ? mt : mt + 'px';
    minWidth = typeof minWidth === 'string' ? minWidth : minWidth + 'px';
    return (
        <div
            className="ab-skeleton-block"
            style={{
                borderRadius: borderRadius,
                width,
                height,
                marginBottom: mb,
                marginLeft: ml,
                marginRight: mr,
                marginTop: mt,
                minWidth,
            }}
        ></div>
    );
};

Skeleton.propTypes = {
    borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mb: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ml: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mr: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Skeleton;
